
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class CertificationIssueSelectGrid extends _Ext.GridBase<Inventory.CertificationIssueItemsRow,any> {
        protected getColumnsKey() { return 'Inventory.CertificationIssueItems'; }
        protected getDialogType() { return <any>Inventory.CertificationIssueItemsDialog; }
        protected getIdProperty() { return Inventory.CertificationIssueItemsRow.idProperty; }
        protected getLocalTextPrefix() { return Inventory.CertificationIssueItemsRow.localTextPrefix; }
        protected getService() { return Inventory.CertificationIssueSelectItemsService.baseUrl; }

        constructor(container: JQuery, options) {
            super(container, options);
            var partyid = parseInt(options.GridFilters.PartyId);
            if (partyid != null && partyid > 0)
                (this.view.params as TransactionRequest).PartyId = partyid;

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }

        private autoSize;

        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): Inventory.CertificationIssueItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return true; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            return true;

        }

    }

}